import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import "../Form.css";
import useForm from "react-hook-form";
import vars from "../../utils/variables";

const LeaveAppointment = ({ history }) => {
  const id = history.location.state.id;
  const [error, setError] = useState(false);

  const { handleSubmit } = useForm();

  const handleFetch = () => {
    fetch(`${vars.server}/exchange/quitAppointment/` + id, {
      method: "POST",
      body: JSON.stringify(),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => {
        return response.json();
      })
      .then(result => {
        if (result.success) {
          history.push("/dashboard", { state: { id: id } });
        } else {
          setError(result.message);
        }
      });
  };

  return (
    <form onSubmit={handleSubmit(handleFetch)} className="formForm">
      <h1>Termin austreten</h1>
      {error && <p className="errorMessage">Fehler: {error}</p>}
      <p>Um aus dem Termin vollständig auszutreten, bestätigen Sie mit "Termin austreten".</p>
      <br />
      <input type="submit" value="Termin austreten" className="inputRLSubmit delete" />
    </form>
  );
};

export default withRouter(LeaveAppointment);
